var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReceiptPrinter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Receipt_Printer"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Receipt_Printer",
    "data-name": "Receipt Printer",
    clipPath: "url(#clip-Receipt_Printer)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bill_15027461",
    transform: "translate(-1 3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M1,11.341A9.091,9.091,0,0,1,10.091,2.25H91.909A9.091,9.091,0,0,1,101,11.341V34.068a9.091,9.091,0,0,1-9.091,9.091H76a4.545,4.545,0,1,1,0-9.091H91.909V11.341H10.091V34.068H26a4.545,4.545,0,1,1,0,9.091H10.091A9.091,9.091,0,0,1,1,34.068Z",
    transform: "translate(0 0)",
    fill: "#e8eaf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M72.682,14.841H4.5V5.75H72.682Z",
    transform: "translate(12.409 12.409)",
    fill: "#e8eaf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M6,10.3A4.545,4.545,0,0,1,10.545,5.75H56A4.545,4.545,0,0,1,60.545,10.3V69.386a9.091,9.091,0,0,1-9.091,9.091H15.091A9.091,9.091,0,0,1,6,69.386ZM24.182,28.477H42.364V19.386H24.182ZM42.364,46.659H24.182V37.568H42.364ZM24.182,64.841H42.364V55.75H24.182Z",
    transform: "translate(17.727 12.409)",
    fill: "#e8eaf0",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptPrinter);
export default __webpack_public_path__ + "static/media/receipt-printer.72f6be3fc678e9f067c07a68f10f5f56.svg";
export { ForwardRef as ReactComponent };